module.exports = "/images/heatwave@3x.png?5d128f71b58c21a0ecae1fe6398da66f";